import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";

// Global, unscoped styles: self-hosted fonts + design tokens / base element rules.
import "./styles/fonts.css";
import "./styles/base.css";
import "./styles/nav.css";
import "./styles/common.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
